/**
 * GO/src/orderservice/orderservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SqlSelectFilterSortOrder = 'Ascending' | 'Descending';

export const SqlSelectFilterSortOrder = {
    Ascending: 'Ascending' as SqlSelectFilterSortOrder,
    Descending: 'Descending' as SqlSelectFilterSortOrder
};
